import { Dialog } from "primereact/dialog";

import "./index.scss";

export default function PDFViewerPopUp({ pdfViewerInfo, showPDFViewer, onHide = null }) {
  return (
    <Dialog
      maximizable
      visible={showPDFViewer}
      header={pdfViewerInfo?.headerName}
      style={{ width: "80vw" }}
      onHide={() => onHide()}
      className="version-history-dialog"
      headerClassName="version-history-dialog-header"
    >
      <iframe
        src={pdfViewerInfo?.proofscopeURL}
        title="File Content"
        style={{ width: "100%", height: "500px" }}
      />
    </Dialog>
  );
}
